import style from '../style/input.module.css'

export default function MiniSeletor({ mes, setMes}) {
  return (
    <select
      name="mes"
      id="mes"
      value={mes}
      onChange={(e) => setMes(e.target.value)}
      className={style.miniSeletor}
    >
      <option value="meses">Mês</option>
      <option value="Janeiro">Janeiro</option>
      <option value="Fevereiro">Fevereiro</option>
      <option value="Março">Março</option>
      <option value="Abril">Abril</option>
      <option value="Maio">Maio</option>
      <option value="Junho">Junho</option>
      <option value="Julho">Julho</option>
      <option value="Agosto">Agosto</option>
      <option value="Setembro">Setembro</option>
      <option value="Outubro">Outubro</option>
      <option value="Novembro">Novembro</option>
      <option value="Dezembro">Dezembro</option>
    </select>
  );
}
